import { Component } from '@angular/core';
import { GridColumnComponent } from './base-grid-column-component';

@Component({
  selector: 'st-grid-column-default',
  template: `<span>{{context[type]}}</span>`
})
export class DefaultGridColumnComponent extends GridColumnComponent {}
